import { Box, Button, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import FilterButton from '../../components/common/FilterButton';

type Props = {
    mode: string;
    setMode: (m: string) => void;
    isFilterVisible: boolean;
    setFilterVisible: (v: boolean) => void;
    roleSelected: string;
    classes?: any;
    onBack?: () => void;
}

const UserManagementHeader = ({ mode, setMode, isFilterVisible, setFilterVisible, roleSelected, classes, onBack }: Props) => {
    return (
        <Typography component="div" display={"flex"} flexDirection={"row"} justifyContent={"space-between"}>
            <Typography component="div" sx={{ pl: 1, letterSpacing: 0.4 }} display={"flex"} flexDirection={"column"} className={classes?.labelNoto16Bold700}>
                <Typography component="span" sx={{ mt: 3 }} className={classes?.labelNoto20Bold600}>
                    <ArrowBackIcon sx={{ verticalAlign: "middle", transform: 'scaleX(1.3)', transformOrigin: 'center left', marginRight: 0.5, cursor: "pointer" }} onClick={onBack} /> <Typography component="span" className={classes?.labelNoto20Bold600}>Back</Typography>
                </Typography>
                <Typography component="span" sx={{ ml: 1.5, letterSpacing: 0.4, mt: 1.5 }} className={classes?.labelNoto36Bold700}>
                    {mode == "view" ? "User Management" : `${mode} User`}
                </Typography>
            </Typography>
            {mode == "view" && <Box sx={{ display: 'flex', alignItems: 'end', my: 1, pr: 1, gap: 2 }}>
                <FilterButton isFilterVisible={isFilterVisible} setFilterVisible={setFilterVisible} />
                {[("Admin"), ("S2S-Lead")].includes(roleSelected) && <Button variant="contained" startIcon={<AddIcon />} onClick={() => setMode("Add")} disableRipple sx={() => ({ padding: "10px 12px" })} className={classes?.greenButton}> Add User</Button>}
            </Box>}
        </Typography>
    );
}

export default UserManagementHeader;
